import authService, { TOKEN_TYPES } from "./authService";

class BaseAPI {
  getToken(): string {
    return authService.getToken(TOKEN_TYPES.ACCESS) ?? "";
  }

  async create(endpoint: string, payload: unknown): Promise<Response> {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/`,
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      },
    );
    return response;
  }

  async patch(
    endpoint: string,
    id: string | number,
    payload: unknown,
  ): Promise<Response> {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/${id}/`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      },
    );
    return response;
  }

  async read(endpoint: string, id?: string | number): Promise<unknown> {
    if (id) {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            "Content-Type": "application/json",
          },
        },
      );
      return response.json();
    }
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/`,
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response.json();
  }

  async update(
    endpoint: string,
    id: string | number,
    payload: unknown,
  ): Promise<unknown> {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/${id}/`,
      {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      },
    );
    return response.json();
  }

  async delete(endpoint: string, id: string | number): Promise<unknown> {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${endpoint}/${id}/`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      },
    );
    if (!response.ok) {
      throw new Error("Failed to delete resource");
    }
    return response.json();
  }
}

const api = new BaseAPI();
export default api;
